import Glide from '@glidejs/glide'
import { q } from '../helper/q'

export const sliderInit = () => {
  const slider = q('.informationSlider')
  if (slider) {
    const glide = new Glide('.informationSlider', {
      autoplay: 4000,
      hoverpause: true
    }).mount()

    q('.informationSliderButtonPrev').addEventListener('click', () => {
      glide.go('<')
    })

    q('.informationSliderButtonNext').addEventListener('click', () => {
      glide.go('>')
    })

    glide.on('move.after', el => {
      q('.informationSliderCurrent span').innerHTML = glide.index + 1
    })
    if (glide._c.Html.slides.length <= 1) {
      ;(q('.informationSliderButtonPrev').style.opacity = 0),
        (q('.informationSliderButtonNext').style.opacity = 0),
        (q('.informationSliderCurrent').style.opacity = 0)
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 100)
  }
}
